// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ConfirmEmailChangeData, ConfirmEmailChangeErrors, ConfirmEmailChangeResponses, ConfirmPasswordRecoveryData, ConfirmPasswordRecoveryErrors, ConfirmPasswordRecoveryResponses, DeleteAvatarData, DeleteAvatarErrors, DeleteAvatarResponses, DetachOauthIdentityData, DetachOauthIdentityErrors, DetachOauthIdentityResponses, GetMeData, GetMeErrors, GetMeResponses, GetUserData, GetUserErrors, GetUserResponses, ListSessionsData, ListSessionsErrors, ListSessionsResponses, LoginData, LoginErrors, LoginMethodsData, LoginMethodsErrors, LoginMethodsResponses, LoginResponses, LogoutCurrentSessionData, LogoutCurrentSessionErrors, LogoutCurrentSessionResponses, LogoutData, LogoutErrors, LogoutOtherSessionsData, LogoutOtherSessionsErrors, LogoutOtherSessionsResponses, LogoutResponses, LogoutSessionData, LogoutSessionErrors, LogoutSessionResponses, OauthCallbackData, OauthCallbackErrors, OauthCallbackResponses, OauthCompletionData, OauthCompletionErrors, OauthCompletionResponses, OauthEmailMatchConfirmData, OauthEmailMatchConfirmErrors, OauthEmailMatchConfirmResponses, OauthLinkStartData, OauthLinkStartErrors, OauthLinkStartResponses, OauthOnboardingEmailConfirmData, OauthOnboardingEmailConfirmErrors, OauthOnboardingEmailConfirmResponses, OauthOnboardingEmailSendData, OauthOnboardingEmailSendErrors, OauthOnboardingEmailSendResponses, OauthOnboardingProfileCompleteData, OauthOnboardingProfileCompleteErrors, OauthOnboardingProfileCompleteResponses, OauthOnboardingProfileData, OauthOnboardingProfileErrors, OauthOnboardingProfileResponses, OauthOnboardingProfileSaveData, OauthOnboardingProfileSaveErrors, OauthOnboardingProfileSaveResponses, OauthProvidersData, OauthProvidersErrors, OauthProvidersResponses, OauthStartData, OauthStartErrors, OauthStartResponses, RefreshData, RefreshErrors, RefreshResponses, RegisterData, RegisterErrors, RegisterResponses, RequestEmailChangeData, RequestEmailChangeErrors, RequestEmailChangeResponses, RequestPasswordRecoveryData, RequestPasswordRecoveryErrors, RequestPasswordRecoveryResponses, SearchUsersData, SearchUsersErrors, SearchUsersResponses, UpdateProfileNameData, UpdateProfileNameErrors, UpdateProfileNameResponses, UpdateUsernameData, UpdateUsernameErrors, UpdateUsernameResponses, UploadAvatarData, UploadAvatarErrors, UploadAvatarResponses, VerifyEmailData, VerifyEmailErrors, VerifyEmailResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

export class AuthService {
    /**
     * Удаление аватара
     *
     * Удаляет текущий аватар пользователя
     */
    public static deleteAvatar<ThrowOnError extends boolean = false>(options?: Options<DeleteAvatarData, ThrowOnError>): RequestResult<DeleteAvatarResponses, DeleteAvatarErrors, ThrowOnError> {
        return (options?.client ?? client).delete<DeleteAvatarResponses, DeleteAvatarErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/avatar',
            ...options
        });
    }
    
    /**
     * Загрузка аватара
     *
     * Позволяет авторизованному пользователю загрузить аватар (файл до 10МБ)
     */
    public static uploadAvatar<ThrowOnError extends boolean = false>(options: Options<UploadAvatarData, ThrowOnError>): RequestResult<UploadAvatarResponses, UploadAvatarErrors, ThrowOnError> {
        return (options.client ?? client).post<UploadAvatarResponses, UploadAvatarErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/avatar',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static confirmEmailChange<ThrowOnError extends boolean = false>(options: Options<ConfirmEmailChangeData, ThrowOnError>): RequestResult<ConfirmEmailChangeResponses, ConfirmEmailChangeErrors, ThrowOnError> {
        return (options.client ?? client).post<ConfirmEmailChangeResponses, ConfirmEmailChangeErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/email/change/confirm',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static requestEmailChange<ThrowOnError extends boolean = false>(options: Options<RequestEmailChangeData, ThrowOnError>): RequestResult<RequestEmailChangeResponses, RequestEmailChangeErrors, ThrowOnError> {
        return (options.client ?? client).post<RequestEmailChangeResponses, RequestEmailChangeErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/email/change/request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Вход в систему
     *
     * Аутентифицирует пользователя и возвращает токены доступа
     */
    public static login<ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, LoginErrors, ThrowOnError> {
        return (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
            url: '/api/v1/auth/login',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Способы входа
     */
    public static loginMethods<ThrowOnError extends boolean = false>(options?: Options<LoginMethodsData, ThrowOnError>): RequestResult<LoginMethodsResponses, LoginMethodsErrors, ThrowOnError> {
        return (options?.client ?? client).get<LoginMethodsResponses, LoginMethodsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/login-methods',
            ...options
        });
    }
    
    /**
     * Выход из системы
     *
     * Деактивирует текущую сессию пользователя (инвалидирует refresh_token)
     */
    public static logout<ThrowOnError extends boolean = false>(options: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> {
        return (options.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/logout',
            ...options
        });
    }
    
    /**
     * Профиль текущего пользователя
     *
     * Возвращает данные текущего авторизованного пользователя
     */
    public static getMe<ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> {
        return (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/me',
            ...options
        });
    }
    
    /**
     * Получить одноразовый результат OAuth
     */
    public static oauthCompletion<ThrowOnError extends boolean = false>(options: Options<OauthCompletionData, ThrowOnError>): RequestResult<OauthCompletionResponses, OauthCompletionErrors, ThrowOnError> {
        return (options.client ?? client).get<OauthCompletionResponses, OauthCompletionErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/completion', ...options });
    }
    
    /**
     * Подтвердить совпадение OAuth email
     */
    public static oauthEmailMatchConfirm<ThrowOnError extends boolean = false>(options: Options<OauthEmailMatchConfirmData, ThrowOnError>): RequestResult<OauthEmailMatchConfirmResponses, OauthEmailMatchConfirmErrors, ThrowOnError> {
        return (options.client ?? client).post<OauthEmailMatchConfirmResponses, OauthEmailMatchConfirmErrors, ThrowOnError>({
            url: '/api/v1/auth/oauth/email/confirm',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Подтвердить email OAuth onboarding
     */
    public static oauthOnboardingEmailConfirm<ThrowOnError extends boolean = false>(options: Options<OauthOnboardingEmailConfirmData, ThrowOnError>): RequestResult<OauthOnboardingEmailConfirmResponses, OauthOnboardingEmailConfirmErrors, ThrowOnError> {
        return (options.client ?? client).post<OauthOnboardingEmailConfirmResponses, OauthOnboardingEmailConfirmErrors, ThrowOnError>({
            url: '/api/v1/auth/oauth/onboarding/email/confirm',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Отправить код OAuth onboarding
     */
    public static oauthOnboardingEmailSend<ThrowOnError extends boolean = false>(options: Options<OauthOnboardingEmailSendData, ThrowOnError>): RequestResult<OauthOnboardingEmailSendResponses, OauthOnboardingEmailSendErrors, ThrowOnError> {
        return (options.client ?? client).post<OauthOnboardingEmailSendResponses, OauthOnboardingEmailSendErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/onboarding/email/send', ...options });
    }
    
    /**
     * Профиль OAuth onboarding
     */
    public static oauthOnboardingProfile<ThrowOnError extends boolean = false>(options: Options<OauthOnboardingProfileData, ThrowOnError>): RequestResult<OauthOnboardingProfileResponses, OauthOnboardingProfileErrors, ThrowOnError> {
        return (options.client ?? client).get<OauthOnboardingProfileResponses, OauthOnboardingProfileErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/onboarding/profile', ...options });
    }
    
    /**
     * Сохранить профиль OAuth onboarding
     */
    public static oauthOnboardingProfileSave<ThrowOnError extends boolean = false>(options: Options<OauthOnboardingProfileSaveData, ThrowOnError>): RequestResult<OauthOnboardingProfileSaveResponses, OauthOnboardingProfileSaveErrors, ThrowOnError> {
        return (options.client ?? client).put<OauthOnboardingProfileSaveResponses, OauthOnboardingProfileSaveErrors, ThrowOnError>({
            url: '/api/v1/auth/oauth/onboarding/profile',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Завершить OAuth onboarding
     */
    public static oauthOnboardingProfileComplete<ThrowOnError extends boolean = false>(options: Options<OauthOnboardingProfileCompleteData, ThrowOnError>): RequestResult<OauthOnboardingProfileCompleteResponses, OauthOnboardingProfileCompleteErrors, ThrowOnError> {
        return (options.client ?? client).post<OauthOnboardingProfileCompleteResponses, OauthOnboardingProfileCompleteErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/onboarding/profile/complete', ...options });
    }
    
    /**
     * Доступные OAuth-провайдеры
     */
    public static oauthProviders<ThrowOnError extends boolean = false>(options?: Options<OauthProvidersData, ThrowOnError>): RequestResult<OauthProvidersResponses, OauthProvidersErrors, ThrowOnError> {
        return (options?.client ?? client).get<OauthProvidersResponses, OauthProvidersErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/providers', ...options });
    }
    
    /**
     * Отвязать OAuth-провайдера
     */
    public static detachOauthIdentity<ThrowOnError extends boolean = false>(options: Options<DetachOauthIdentityData, ThrowOnError>): RequestResult<DetachOauthIdentityResponses, DetachOauthIdentityErrors, ThrowOnError> {
        return (options.client ?? client).delete<DetachOauthIdentityResponses, DetachOauthIdentityErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/oauth/{provider}',
            ...options
        });
    }
    
    /**
     * OAuth callback
     */
    public static oauthCallback<ThrowOnError extends boolean = false>(options: Options<OauthCallbackData, ThrowOnError>): RequestResult<OauthCallbackResponses, OauthCallbackErrors, ThrowOnError> {
        return (options.client ?? client).get<OauthCallbackResponses, OauthCallbackErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/{provider}/callback', ...options });
    }
    
    /**
     * Начать привязку OAuth
     */
    public static oauthLinkStart<ThrowOnError extends boolean = false>(options: Options<OauthLinkStartData, ThrowOnError>): RequestResult<OauthLinkStartResponses, OauthLinkStartErrors, ThrowOnError> {
        return (options.client ?? client).get<OauthLinkStartResponses, OauthLinkStartErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/{provider}/link', ...options });
    }
    
    /**
     * Начать OAuth-вход
     */
    public static oauthStart<ThrowOnError extends boolean = false>(options: Options<OauthStartData, ThrowOnError>): RequestResult<OauthStartResponses, OauthStartErrors, ThrowOnError> {
        return (options.client ?? client).get<OauthStartResponses, OauthStartErrors, ThrowOnError>({ url: '/api/v1/auth/oauth/{provider}/start', ...options });
    }
    
    /**
     * Смена пароля
     */
    public static changePassword<ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> {
        return (options.client ?? client).put<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/password',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static confirmPasswordRecovery<ThrowOnError extends boolean = false>(options: Options<ConfirmPasswordRecoveryData, ThrowOnError>): RequestResult<ConfirmPasswordRecoveryResponses, ConfirmPasswordRecoveryErrors, ThrowOnError> {
        return (options.client ?? client).post<ConfirmPasswordRecoveryResponses, ConfirmPasswordRecoveryErrors, ThrowOnError>({
            url: '/api/v1/auth/password/recovery/confirm',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    public static requestPasswordRecovery<ThrowOnError extends boolean = false>(options: Options<RequestPasswordRecoveryData, ThrowOnError>): RequestResult<RequestPasswordRecoveryResponses, RequestPasswordRecoveryErrors, ThrowOnError> {
        return (options.client ?? client).post<RequestPasswordRecoveryResponses, RequestPasswordRecoveryErrors, ThrowOnError>({
            url: '/api/v1/auth/password/recovery/request',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Изменение имени и фамилии
     */
    public static updateProfileName<ThrowOnError extends boolean = false>(options: Options<UpdateProfileNameData, ThrowOnError>): RequestResult<UpdateProfileNameResponses, UpdateProfileNameErrors, ThrowOnError> {
        return (options.client ?? client).put<UpdateProfileNameResponses, UpdateProfileNameErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/profile/name',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Обновление токена
     *
     * Обновляет access token с помощью refresh cookie
     */
    public static refresh<ThrowOnError extends boolean = false>(options: Options<RefreshData, ThrowOnError>): RequestResult<RefreshResponses, RefreshErrors, ThrowOnError> {
        return (options.client ?? client).post<RefreshResponses, RefreshErrors, ThrowOnError>({ url: '/api/v1/auth/refresh', ...options });
    }
    
    /**
     * Регистрация
     *
     * Регистрирует нового пользователя
     */
    public static register<ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>): RequestResult<RegisterResponses, RegisterErrors, ThrowOnError> {
        return (options.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
            url: '/api/v1/auth/register',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Активные устройства
     */
    public static listSessions<ThrowOnError extends boolean = false>(options?: Options<ListSessionsData, ThrowOnError>): RequestResult<ListSessionsResponses, ListSessionsErrors, ThrowOnError> {
        return (options?.client ?? client).get<ListSessionsResponses, ListSessionsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/sessions',
            ...options
        });
    }
    
    /**
     * Завершить текущую сессию
     */
    public static logoutCurrentSession<ThrowOnError extends boolean = false>(options?: Options<LogoutCurrentSessionData, ThrowOnError>): RequestResult<LogoutCurrentSessionResponses, LogoutCurrentSessionErrors, ThrowOnError> {
        return (options?.client ?? client).delete<LogoutCurrentSessionResponses, LogoutCurrentSessionErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/sessions/current',
            ...options
        });
    }
    
    /**
     * Завершить другие сессии
     */
    public static logoutOtherSessions<ThrowOnError extends boolean = false>(options?: Options<LogoutOtherSessionsData, ThrowOnError>): RequestResult<LogoutOtherSessionsResponses, LogoutOtherSessionsErrors, ThrowOnError> {
        return (options?.client ?? client).delete<LogoutOtherSessionsResponses, LogoutOtherSessionsErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/sessions/others',
            ...options
        });
    }
    
    /**
     * Завершить сессию устройства
     */
    public static logoutSession<ThrowOnError extends boolean = false>(options: Options<LogoutSessionData, ThrowOnError>): RequestResult<LogoutSessionResponses, LogoutSessionErrors, ThrowOnError> {
        return (options.client ?? client).delete<LogoutSessionResponses, LogoutSessionErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/sessions/{id}',
            ...options
        });
    }
    
    /**
     * Смена username
     *
     * Позволяет авторизованному пользователю изменить свой username
     */
    public static updateUsername<ThrowOnError extends boolean = false>(options: Options<UpdateUsernameData, ThrowOnError>): RequestResult<UpdateUsernameResponses, UpdateUsernameErrors, ThrowOnError> {
        return (options.client ?? client).put<UpdateUsernameResponses, UpdateUsernameErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/username',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Поиск пользователей
     *
     * Ищет пользователей по части email
     */
    public static searchUsers<ThrowOnError extends boolean = false>(options?: Options<SearchUsersData, ThrowOnError>): RequestResult<SearchUsersResponses, SearchUsersErrors, ThrowOnError> {
        return (options?.client ?? client).get<SearchUsersResponses, SearchUsersErrors, ThrowOnError>({
            security: [{ name: 'Authorization', type: 'apiKey' }, {
                    in: 'cookie',
                    name: '__SecureAccessToken',
                    type: 'apiKey'
                }],
            url: '/api/v1/auth/users',
            ...options
        });
    }
    
    /**
     * Получение пользователя по ID
     *
     * Возвращает профиль пользователя по его UUID
     */
    public static getUser<ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>): RequestResult<GetUserResponses, GetUserErrors, ThrowOnError> {
        return (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({ url: '/api/v1/auth/users/{id}', ...options });
    }
    
    /**
     * Подтверждение почты
     *
     * Подтверждает почту пользователя с помощью 6-значного кода
     */
    public static verifyEmail<ThrowOnError extends boolean = false>(options: Options<VerifyEmailData, ThrowOnError>): RequestResult<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError> {
        return (options.client ?? client).post<VerifyEmailResponses, VerifyEmailErrors, ThrowOnError>({
            url: '/api/v1/auth/verify',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
